var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 9,
    height: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#d52b1e",
    y: 3,
    width: 9,
    height: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#0039a6",
    y: 2,
    width: 9,
    height: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.f6bf75dc753a7e2944a7871bcdd29e60.svg";
export { ForwardRef as ReactComponent };